<template>
    <div>
        <!-- Navbar -->
        <v-app-bar app elevation="0" color="#1B2557" dark style="z-index: 10;">
            <v-toolbar-title style="font-weight: 800; font-size: 18px; letter-spacing: -0.5px; cursor: pointer;" @click="$router.push('/')">
                IVYED
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small @click="scrollTo('stats')">성과</v-btn>
            <v-btn text small @click="scrollTo('about')">부트캠프</v-btn>
            <v-btn text small @click="scrollTo('curriculum')">커리큘럼</v-btn>
            <v-btn text small @click="scrollTo('reviews')">후기</v-btn>
            <v-btn text small @click="scrollTo('cta')">신청</v-btn>
        </v-app-bar>

        <!-- Hero -->
        <div style="background: linear-gradient(135deg, #1B2557 0%, #2B3A7E 50%, #3A4CAA 100%); min-height: 100vh; display: flex; align-items: center;">
            <div style="width: 100%; padding: 80px 24px;">
                <v-row align="center" style="max-width: 1100px; margin: 0 auto;">
                    <v-col cols="12" md="7">
                        <div style="display: inline-block; background: rgba(255,255,255,0.15); color: #fff; padding: 6px 20px; border-radius: 20px; font-size: 14px; font-weight: 600; letter-spacing: 1px; margin-bottom: 24px;">
                            2026 여름방학
                        </div>
                        <h1 style="color: #fff; font-size: 42px; font-weight: 800; line-height: 1.3; margin-bottom: 20px; letter-spacing: -1px;">
                            AP Computer Science A
                            <br/>완벽대비 Bootcamp
                        </h1>
                        <p style="color: rgba(255,255,255,0.85); font-size: 17px; line-height: 1.7; margin-bottom: 24px;">
                            아이비리그 컴퓨터공학 출신이 직접 밀착 지도하는
                            <br/>8주 소수정예 부트캠프
                        </p>
                        <div style="margin-bottom: 8px;">
                            <v-chip dark outlined class="ma-1">
                                <v-icon left small>mdi-calendar</v-icon>
                                6월 개강 · 8주 과정
                            </v-chip>
                            <v-chip dark outlined class="ma-1">
                                <v-icon left small>mdi-clock-outline</v-icon>
                                주 2회 · 90분
                            </v-chip>
                            <v-chip dark outlined class="ma-1">
                                <v-icon left small>mdi-account-group</v-icon>
                                소수정예
                            </v-chip>
                        </div>
                        <div class="pt-8">
                            <v-btn x-large color="#EF0006" dark
                                   style="font-weight: 700; font-size: 16px; letter-spacing: -0.5px; border-radius: 8px; padding: 0 32px;"
                                   to="/bootcamp/register">
                                부트캠프 문의하기
                                <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" md="5" class="text-center">
                        <img src="../../assets/mentors.png"
                             style="max-width: 100%; border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.3);"
                             alt="IVYED 선생님들"/>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Stats -->
        <div id="stats" style="background: #FFFFFF; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 48px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">RESULTS</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">숫자로 증명합니다</h2>
                </div>
                <v-row>
                    <v-col cols="6" md="3" class="text-center" style="padding: 16px;">
                        <div style="color: #EF0006; font-size: 48px; font-weight: 800; line-height: 1;">97%</div>
                        <div style="color: #4A4A4A; font-size: 14px; font-weight: 600; margin-top: 8px;">AP 5점 취득률</div>
                    </v-col>
                    <v-col cols="6" md="3" class="text-center" style="padding: 16px;">
                        <div style="color: #EF0006; font-size: 48px; font-weight: 800; line-height: 1;">96%</div>
                        <div style="color: #4A4A4A; font-size: 14px; font-weight: 600; margin-top: 8px;">Java 프로그래밍 능력</div>
                    </v-col>
                    <v-col cols="6" md="3" class="text-center" style="padding: 16px;">
                        <div style="color: #EF0006; font-size: 48px; font-weight: 800; line-height: 1;">99%</div>
                        <div style="color: #4A4A4A; font-size: 14px; font-weight: 600; margin-top: 8px;">수업 만족도</div>
                    </v-col>
                    <v-col cols="6" md="3" class="text-center" style="padding: 16px;">
                        <div style="color: #EF0006; font-size: 48px; font-weight: 800; line-height: 1;">98%</div>
                        <div style="color: #4A4A4A; font-size: 14px; font-weight: 600; margin-top: 8px;">재수강률</div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- What is it + Target -->
        <div id="about" style="background: #F5F7FA; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div style="margin-bottom: 48px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">ABOUT</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px; margin-bottom: 16px;">AP CSA 부트캠프란?</h2>
                    <p style="color: #4A4A4A; font-size: 15px; line-height: 1.8;">
                        아직도 대규모 특강에 현혹되고 계신가요? 아이비에드 AP CSA 부트캠프에서는 컴퓨터공학 대학과정 기초부터 프로그래밍 과제 실습까지 탄탄하게 잡아주는 최고의 쌍방향 소통 부트캠프입니다.
                    </p>
                    <p style="color: #4A4A4A; font-size: 15px; line-height: 1.8; margin-top: 12px;">
                        단순한 지식 전달에 그치지 않습니다. 계속해서 질문하고 성장할 수 있게 실시간으로 교육합니다.
                        부트캠프 진행기간 동안 학교 과제까지 직접 도움받으며 실력을 쌓을 수 있습니다.
                    </p>
                </div>
                <h3 style="color: #1A1A1A; font-size: 20px; font-weight: 700; margin-bottom: 16px;">이런 학생에게 추천합니다</h3>
                <v-row>
                    <v-col cols="12" md="6">
                        <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                            <v-icon color="#EF0006" style="margin-right: 12px; margin-top: 2px;">mdi-check-circle</v-icon>
                            <span style="color: #4A4A4A; font-size: 15px;">여름방학에 미리 AP CSA를 끝내고 싶은 학생</span>
                        </div>
                        <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                            <v-icon color="#EF0006" style="margin-right: 12px; margin-top: 2px;">mdi-check-circle</v-icon>
                            <span style="color: #4A4A4A; font-size: 15px;">Java로 프로그래밍을 할 수 있게 되고 싶은 학생</span>
                        </div>
                    </v-col>
                    <v-col cols="12" md="6">
                        <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                            <v-icon color="#EF0006" style="margin-right: 12px; margin-top: 2px;">mdi-check-circle</v-icon>
                            <span style="color: #4A4A4A; font-size: 15px;">AP CSA 수업을 듣지 않고도 시험을 보고 싶은 학생</span>
                        </div>
                        <div style="display: flex; align-items: flex-start; margin-bottom: 12px;">
                            <v-icon color="#EF0006" style="margin-right: 12px; margin-top: 2px;">mdi-check-circle</v-icon>
                            <span style="color: #4A4A4A; font-size: 15px;">프로그래밍 실력을 향상하고 싶은 학생</span>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Video -->
        <div style="background: #FFFFFF; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 32px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">PREVIEW</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">강의 미리보기</h2>
                </div>
                <div class="text-center">
                    <div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);">
                        <iframe style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
                                src="https://www.youtube.com/embed/_PqE5TJbtmo?si=Wt2a-t1VPUxIrNEd"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>

        <!-- Differentiators -->
        <div style="background: #F5F7FA; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 48px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">DIFFERENCE</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">아이비에드 부트캠프는 이렇게 다릅니다</h2>
                    <p style="color: #4A4A4A; font-size: 15px; margin-top: 8px;">
                        단기 속성반으로 보장할 수 없는 점수를 약속하지 않습니다.<br/>
                        실시간 수업과 과제 도우미 및 시험문제 풀이로 AP CSA 대비뿐 아닌 Java의 이해도도 함께 키워갑니다.
                    </p>
                </div>
                <v-row>
                    <v-col cols="12" md="6" style="padding: 12px;">
                        <v-card flat style="padding: 28px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <v-icon color="#1B2557" size="36" style="margin-bottom: 16px;">mdi-book-open-variant</v-icon>
                            <div style="font-size: 18px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">온라인 스터디 진행</div>
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">
                                매주 공부의 루틴을 자동적으로 잡아주는 과제와 시험이 있으며 스스로 공부한다면 놓치기 쉬운 부분과 복습 점검까지 철저하게 지도하고 있습니다.
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 12px;">
                        <v-card flat style="padding: 28px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <v-icon color="#1B2557" size="36" style="margin-bottom: 16px;">mdi-account-question</v-icon>
                            <div style="font-size: 18px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">실시간 질의응답</div>
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">
                                Computer Science는 처음부터 체계적인 전문 선생님께 지도를 받으면 구글링하며 헤매는 시간을 100시간에서 단 몇시간으로 절약할 수 있는 과목입니다.
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 12px;">
                        <v-card flat style="padding: 28px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <v-icon color="#1B2557" size="36" style="margin-bottom: 16px;">mdi-infinity</v-icon>
                            <div style="font-size: 18px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">기간 제한 없는 학습 지원</div>
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">
                                학습이 끝난 후에도 시험 기간 동안 무제한 복습 과제와 강의를 제공합니다. 다년간 AP Computer Science 대비를 위한 교재와 PDF 자료를 제공합니다.
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6" style="padding: 12px;">
                        <v-card flat style="padding: 28px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <v-icon color="#1B2557" size="36" style="margin-bottom: 16px;">mdi-video</v-icon>
                            <div style="font-size: 18px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">수업 녹화본 무기한 제공</div>
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">
                                매 수업 이후 당일 수업 녹화본이 참여 학생들 한정으로 무기한 제공되어 언제든 헷갈렸던 부분을 복습할 수 있도록 환경을 만들었습니다.
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Curriculum -->
        <div id="curriculum" style="background: #FFFFFF; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 48px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">CURRICULUM</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">8주 상세 커리큘럼</h2>
                    <p style="color: #4A4A4A; font-size: 15px; margin-top: 8px;">아이비리그 Computer Science 전공 재학생 선배들이 인정한 커리큘럼</p>
                </div>
                <v-expansion-panels flat>
                    <v-expansion-panel v-for="(item, i) in curriculum" :key="i"
                                       style="margin-bottom: 8px; border: 1px solid #E8ECF0; border-radius: 8px !important;">
                        <v-expansion-panel-header style="font-size: 15px; font-weight: 700; color: #1A1A1A;">
                            <span><span style="color: #EF0006; margin-right: 8px;">Week {{i + 1}}</span>{{item.title}}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="font-size: 14px; color: #4A4A4A; line-height: 2;">
                            <div v-for="(topic, j) in item.topics" :key="j">• {{topic}}</div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>

        <!-- Class Material Preview -->
        <div style="background: #F5F7FA; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 32px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">MATERIALS</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">실제 수업 자료</h2>
                    <p style="color: #4A4A4A; font-size: 15px; margin-top: 8px;">체계적으로 구성된 교재와 실습 자료로 학습합니다</p>
                </div>
                <v-row>
                    <v-col cols="12" md="4">
                        <img src="../../assets/apcs1.png" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="AP CS 자료 1"/>
                    </v-col>
                    <v-col cols="12" md="4">
                        <img src="../../assets/apcs2.jpeg" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="AP CS 자료 2"/>
                    </v-col>
                    <v-col cols="12" md="4">
                        <img src="../../assets/apcs3.jpeg" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="AP CS 자료 3"/>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Homework Screenshots -->
        <div style="background: #FFFFFF; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 32px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">HOMEWORK</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">매주 과제와 실습</h2>
                    <p style="color: #4A4A4A; font-size: 15px; margin-top: 8px;">매주 체계적인 과제로 배운 내용을 확실하게 자기것으로 만듭니다</p>
                </div>
                <v-row>
                    <v-col cols="12" md="4">
                        <img src="../../assets/cshomework1.png" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="숙제 1"/>
                    </v-col>
                    <v-col cols="12" md="4">
                        <img src="../../assets/cshomework2.png" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="숙제 2"/>
                    </v-col>
                    <v-col cols="12" md="4">
                        <img src="../../assets/cshomework3.png" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="숙제 3"/>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Program Details -->
        <div style="background: #F5F7FA; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 48px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">SUPPORT</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">수업 외 지원 프로그램</h2>
                </div>
                <v-row>
                    <v-col cols="12" md="4" style="padding: 12px;">
                        <v-card flat style="border-radius: 12px; overflow: hidden; height: 100%; border: 1px solid #E8ECF0;">
                            <img src="../../assets/record-videos-coursifyme.jpeg" style="width: 100%; height: 180px; object-fit: cover;" alt="녹화본"/>
                            <div style="padding: 20px;">
                                <div style="font-size: 16px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">수업 녹화본 제공</div>
                                <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">매 수업 녹화본을 무기한 제공하여 언제든 복습할 수 있습니다.</div>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 12px;">
                        <v-card flat style="border-radius: 12px; overflow: hidden; height: 100%; border: 1px solid #E8ECF0;">
                            <img src="../../assets/consulting.jpg" style="width: 100%; height: 180px; object-fit: cover;" alt="상담"/>
                            <div style="padding: 20px;">
                                <div style="font-size: 16px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">1:1 멘토링 상담</div>
                                <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">아이비리그 선생님과 주 단위 기술 멘토링을 통해 방향성을 제공합니다.</div>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 12px;">
                        <v-card flat style="border-radius: 12px; overflow: hidden; height: 100%; border: 1px solid #E8ECF0;">
                            <img src="../../assets/study-group.jpeg" style="width: 100%; height: 180px; object-fit: cover;" alt="스터디"/>
                            <div style="padding: 20px;">
                                <div style="font-size: 16px; font-weight: 700; color: #1A1A1A; margin-bottom: 8px;">스터디 그룹</div>
                                <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7;">수준에 따른 맞춤 학습과 지원을 통해 자기주도적으로 학습합니다.</div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <!-- After class screenshots -->
                <v-row class="mt-8">
                    <v-col cols="12" md="6">
                        <img src="../../assets/수업이끝나면1.png" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="수업 후 1"/>
                    </v-col>
                    <v-col cols="12" md="6">
                        <img src="../../assets/수업이끝나면2.png" style="width: 100%; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);" alt="수업 후 2"/>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- Reviews -->
        <div id="reviews" style="background: #FFFFFF; padding: 64px 24px;">
            <div style="max-width: 900px; margin: 0 auto;">
                <div class="text-center" style="margin-bottom: 48px;">
                    <div style="color: #EF0006; font-size: 13px; font-weight: 700; letter-spacing: 2px; margin-bottom: 8px;">REVIEWS</div>
                    <h2 style="color: #1A1A1A; font-size: 28px; font-weight: 800; letter-spacing: -0.5px;">수강생 후기</h2>
                    <p style="color: #4A4A4A; font-size: 15px; margin-top: 8px;">성적만 높은게 아닙니다. 입시 경쟁력 및 프로그래밍 실력도 길러줍니다.</p>
                </div>
                <!-- Testimonial -->
                <div class="text-center" style="margin-bottom: 48px;">
                    <v-card flat style="padding: 32px; border-radius: 12px; border: 1px solid #E8ECF0; max-width: 600px; margin: 0 auto;">
                        <img src="../../assets/studentAvatarGirl.png" style="width: 80px; height: 80px; border-radius: 50%; margin-bottom: 16px;" alt="학생"/>
                        <div style="font-size: 16px; color: #1A1A1A; line-height: 1.7; font-style: italic;">
                            "혼자서 시작조차 못했던 AP Computer Science A 공부를 아이비에드를 통해 정말 쉽게 시작했어요."
                        </div>
                        <div style="color: #999; font-size: 13px; margin-top: 12px;">미국 보딩스쿨 재학중</div>
                    </v-card>
                </div>
                <!-- Review Cards -->
                <v-row>
                    <v-col cols="12" md="4" style="padding: 12px;">
                        <v-card flat style="padding: 24px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7; margin-bottom: 16px;">
                                "솔직히 주변에서 유학 준비를 걱정하는 시선이 많았는데 과외받으면서 좋은 성적도 받고 코딩에 흥미를 느껴 전공에 확신이 생겼어요"
                            </div>
                            <div class="text-center">
                                <img src="../../assets/avatar2.png" style="height: 60px;" alt="학생"/>
                                <div style="color: #999; font-size: 12px; font-weight: 600; margin-top: 8px;">국내 국제학교 11학년</div>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 12px;">
                        <v-card flat style="padding: 24px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7; margin-bottom: 16px;">
                                "프로그래밍을 하면서 스스로 문제해결능력을 기르게 되어 자연스럽게 포트폴리오를 만들고 그게 제 입시 준비의 초석이 되었습니다"
                            </div>
                            <div class="text-center">
                                <img src="../../assets/avatar3.png" style="height: 60px;" alt="학생"/>
                                <div style="color: #999; font-size: 12px; font-weight: 600; margin-top: 8px;">미국 동부 보딩스쿨 11학년</div>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4" style="padding: 12px;">
                        <v-card flat style="padding: 24px; border-radius: 12px; height: 100%; border: 1px solid #E8ECF0;">
                            <div style="font-size: 14px; color: #4A4A4A; line-height: 1.7; margin-bottom: 16px;">
                                "AP CSA에서 5점을 받아 그 성적으로 이번 여름 방학 리서치 인턴에 합격했습니다!"
                            </div>
                            <div class="text-center">
                                <img src="../../assets/avatar4.png" style="height: 60px;" alt="학생"/>
                                <div style="color: #999; font-size: 12px; font-weight: 600; margin-top: 8px;">미국 보딩스쿨 12학년</div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>

        <!-- CTA -->
        <div id="cta" style="background: linear-gradient(135deg, #1B2557 0%, #2B3A7E 100%); padding: 80px 24px;">
            <div class="text-center" style="max-width: 600px; margin: 0 auto;">
                <h2 style="color: #fff; font-size: 32px; font-weight: 800; margin-bottom: 16px; letter-spacing: -0.5px;">
                    여름방학, AP CSA 5점의 시작
                </h2>
                <p style="color: rgba(255,255,255,0.8); font-size: 16px; line-height: 1.7; margin-bottom: 32px;">
                    소수정예로 운영되어 인원이 한정되어 있습니다.<br/>
                    지금 바로 문의해주세요.
                </p>
                <v-btn x-large color="#EF0006" dark
                       style="font-weight: 700; font-size: 16px; letter-spacing: -0.5px; border-radius: 8px; padding: 0 40px;"
                       to="/bootcamp/register">
                    부트캠프 문의하기
                    <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BootcampSummer2026",
        data() {
            return {
                curriculum: [
                    {
                        title: "Intro to AP CSA and Java",
                        topics: [
                            "AP CSA 는 어떤 과목이고 어떤 시험인가?",
                            "Java 는 어떤 프로그래밍 언어인가?",
                            "Java를 실행 할 수 있는 환경 구축하기",
                            "주석 (Comments)",
                            "데이터 타입 (Data types in Java)",
                            "연산자 (Operators in Java)",
                            "입출력 (Input / Output)",
                            "조건문 (Control Structures)",
                            "Errors and Exceptions in Java",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Java의 Classes",
                        topics: [
                            "객체지향 프로그래밍 (Object-oriented Programming) 에서 Class가 무엇인가?",
                            "Object(객체)란 무엇이고 어떻게 사용 되는가?",
                            "Object vs. Primitive data types",
                            "Wrapper Class 에 대한 이해",
                            "Java 에서 제공하는 다양한 클래스들 알아보기",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Classes and Objects",
                        topics: [
                            "Objects vs. Classes",
                            "접근제한자 (Access Modifiers) 는 무엇이고 어떻게 사용하는가?",
                            "Java에서의 함수 (Methods) 작성법 및 이해",
                            "Method Overloading",
                            "Scope 개념 및 이해",
                            "Reference vs. Primitive Data Types",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Inheritance and Polymorphism",
                        topics: [
                            "Class Inheritance (상속) 개념 및 이해",
                            "Super Class vs. Sub Class",
                            "Polymorphism",
                            "Dynamic Binding",
                            "Type Compatibility",
                            "Google 과 Youtube 를 상속개념으로 구현 해보기",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Array and ArrayLists",
                        topics: [
                            "배열 (Array)는 왜 필요하며 어떻게 사용하는가?",
                            "1차원 배열 (One-dimensional Array)",
                            "Array vs. ArrayList in Java",
                            "2차원 배열 (Two-dimensional Array)",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Object Oriented Program Design",
                        topics: [
                            "AP CSA 의 필수문제 Object Oriented Program Design",
                            "Software Development",
                            "Program Analysis",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Recursion",
                        topics: [
                            "Recursive Methods",
                            "Recursive 함수의 기본 형태",
                            "How to write recursive methods",
                            "Recursion 을 사용하는 이유",
                            "Recursion vs. Iteration",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    },
                    {
                        title: "Sorting and Searching",
                        topics: [
                            "What are Algorithms?",
                            "Sorting: Selection Sorts, Insertion Sorts, Merge Sorts, Quick Sorts",
                            "Searching: Linear Search, Binary Search",
                            "숙제 (Reading & MCP & Programming)"
                        ]
                    }
                ]
            }
        },
        methods: {
            scrollTo(id) {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({behavior: 'smooth'});
                }
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 600px) {
        h1 {
            font-size: 28px !important;
        }
        h2 {
            font-size: 24px !important;
        }
    }
</style>
